import { FC } from "react";
import { useTranslation } from "react-i18next";

export const Claim: FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <span className="p-1 text-body-xs text-foreground-primary-inverse">
      &#169; {currentYear} {t("Common.companyName")}
    </span>
  );
};
